import React from 'react'

export const Loader = () => {
  return (
    <div className='w-100 vh-75 d-flex justify-content-center align-items-center'>
      <label>
        <span className='indicator-progress d-block'>
          <span className='spinner-border align-middle ms-5 text-info'></span>
        </span>
        Loading...
      </label>
    </div>
  )
}

export default Loader
